module.exports = __webpack_public_path__ + "static/media/ic weather 43.4bd9292d.png";